<template>
	<div class="page">
		<div class="title">
			我的信息
		</div>
		<div class="info-list"><span>昵称：</span>{{userInfo.nickname}}</div>
		<div class="info-list"><span>手机：</span>{{userInfo.mobile}}</div>
		<div class="info-list"><span>邮箱：</span>{{userInfo.email}}</div>
		<div class="info-list"><span>等级：</span>{{memberType(userInfo.type)}}</div>
		<div style="margin: 20px auto;text-align: center;">
			<el-button type="danger" @click="logout">退出登录</el-button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				userInfo:{},
			}
		},
		beforeCreate(){
			if(window.localStorage.getItem("token")){
				this.$axios({
					url:this.$utils.httpApi + 'user/getinfos',
					headers:{
						'token':window.localStorage.getItem("token")
					}
				}).then(res=>{
					this.userInfo = res.data
				})	
			}
		},
		methods:{
		  memberType(type){
			  if(type == 0){
				  return '普通会员'
			  }else if(type == 1){
				  return '月度会员'
			  }else if(type == 2){
				  return '季度会员'
			  }else if(type == 3){
				  return '半年度会员'
			  }else if(type == 4){
				  return '年度会员'
			  }
		  },
		  logout(){
			  window.localStorage.removeItem('token')
			  window.location.reload()
		  }
		}
	}
</script>

<style>
	.page{
	}
	.title{
		font-size: 1.5rem;
		font-weight: 700;
		padding:20px;
	}
	.info-list{
		height: 30px;
		line-height: 30px;
		padding:0px 20px;
	}
	.info-list span{
		font-size: 1.1rem;
		font-weight: 700;
	}
</style>